import commonColors from '@/assets/theme/colors/hex/index.common';
import brandedColors from '@/assets/theme/colors/hex/index.ts';
import { Theme } from '@emotion/react';

const { darkCoolGrey, extraLightGrey, lrGreen, mediumGrey, slateBlue } =
	brandedColors;
const { white, black, light, ring, activeGreen } = commonColors;

const colors: Theme['colors'] = {
	primaryBrandColor: slateBlue.hex(),
	secondaryBrandColor: lrGreen.hex(),
	brandGrayDark: darkCoolGrey.hex(),
	brandGrayMedium: mediumGrey.hex(),
	brandGrayLight: extraLightGrey.hex(),
	keylineColour: darkCoolGrey.alpha(0.3).hexa(),
	primaryNavBackground: white.hex(),
	primaryNavHover: mediumGrey.hex(),
	shadow: black.alpha(0.06).hexa(),
	backdrop: light.alpha(0.85).hexa(),
	focusRing: ring.hex(),
	activeGreen: activeGreen.hex(),
	brandGradient: {
		generic: {
			mobile: 'radial-gradient(50% 50% at 50% 60%, #ffffffe8 0%, #fff0 100%), linear-gradient(180deg, #e0e0e000 0%, #ffffffa6 62%, #e0e0e0 100%), linear-gradient(90deg, #d6dee3 0%, #ece8de 100%)',
			fallback:
				'radial-gradient(60% 60% at 50% 60%, #ffffffe8 0%, #fff0 100%), linear-gradient(180deg, #e0e0e000 0%, #ffffffa6 62%, #e0e0e0 86%), linear-gradient(90deg, #becbd3 1%, #c4d1daff 24%, #e5dccb 78%, #e5dccb 100%)',
		},
		defender: {
			mobile: 'linear-gradient(to bottom, rgb(255 255 255 / 25%), rgb(255 255 255 / 25%)), radial-gradient(circle at 49% 50%, #fff, rgb(255 255 255 / 10%) 103%), linear-gradient(to bottom, rgb(220 220 220 / 0%) 53%, #dcdcdc 100%), linear-gradient(to left, #d2d7df 100%, #d4d9e4 82%, #f6f5f6 50%, #d4d9e4 18%, #d4d9e4 0%)',
			fallback:
				'linear-gradient(to bottom, rgb(255 255 255 / 25%), rgb(255 255 255 / 25%)), radial-gradient(circle at 49% 50%, #fff, rgb(255 255 255 / 0%) 54%), linear-gradient(to bottom, rgb(220 220 220 / 0%) 53%, #dcdcdc 100%), linear-gradient(to left, #d2d7df 100%, #d4d9e4 82%, #fff 50%, #d4d9e4 18%, #d4d9e4 0%)',
		},
		discovery: {
			mobile: 'radial-gradient(70% 50% at 50% 60%, #ffff 0%, #fff0 100%), linear-gradient(180deg, #fff0 1%, #c5c5c58c 100%), linear-gradient(90deg, #f0f0f0 2%, #f9f9f9 52%, #f9f9f9 98%)',
			fallback:
				'radial-gradient(60% 50% at 50% 60%, #ffff 0%, #fff0 100%), linear-gradient(180deg, #e9ecec00 2%, #dee0e0 98%), linear-gradient(90deg, #e9ecec 1%, #f8f9f9 49%, #e9ecec 99%)',
		},
		rangerover: {
			mobile: 'radial-gradient(50% 50% at 50% 60%, #ffffffe8 0%, #fff0 100%), linear-gradient(180deg, #e0e0e000 0%, #ffffffa6 62%, #e0e0e0 100%), linear-gradient(90deg, #d6dee3 0%, #ece8de 100%)',
			fallback:
				'radial-gradient(60% 60% at 50% 60%, #ffffffe8 0%, #fff0 100%), linear-gradient(180deg, #e0e0e000 0%, #ffffffa6 62%, #e0e0e0 86%), linear-gradient(90deg, #becbd3 1%, #c4d1daff 24%, #e5dccb 78%, #e5dccb 100%)',
		},
	},
};

export default colors;
